<template>
  <div space-y-4>
    <h2 text-xl sm:text-2xl font-semibold text-stone-500>More Resources</h2>
    <ul flex flex-wrap gap-5 sm:gap-3>
      <li>
        <NuxtLink
          class="font-bold hover:text-stone-400"
          :to="`/location/${center.latitude},${center.longitude}/${urlName}`"
        >
          {{ displayName }} Elevation
        </NuxtLink>
      </li>
      <li>
        <NuxtLink
          class="font-bold hover:text-stone-400"
          :to="`/snow-totals?lat=${center.latitude}&lng=${center.longitude}&title=${encodeURI(
            decodeUrlTitle(urlName)
          )}`"
        >
          {{ displayName }} Snow Totals
        </NuxtLink>
      </li>
      <li>
        <NuxtLink
          class="font-bold hover:text-stone-400"
          :to="`/rain-totals?lat=${center.latitude}&lng=${center.longitude}&title=${encodeURI(
            decodeUrlTitle(urlName)
          )}`"
        >
          {{ displayName }} Rain Totals
        </NuxtLink>
      </li>
      <li>
        <NuxtLink
          class="font-bold hover:text-stone-400"
          :to="`/what-zone-am-i-in?lat=${center.latitude}&lng=${center.longitude}&title=${encodeURI(
            decodeUrlTitle(urlName)
          )}`"
        >
          {{ displayName }} Plant Hardiness Zone
        </NuxtLink>
      </li>
      <li>
        <NuxtLink
          class="font-bold hover:text-stone-400"
          :to="`/what-school-district-am-i-in?lat=${center.latitude}&lng=${center.longitude}&title=${encodeURI(
            decodeUrlTitle(urlName)
          )}`"
        >
          {{ displayName }} School Districts
        </NuxtLink>
      </li>
      <!-- <li>
        <NuxtLink
          class="font-bold hover:text-stone-400"
          :to="`/what-indigenous-territories-am-i-in?lat=${center.latitude}&lng=${center.longitude}&title=${encodedUrlName}`"
        >
          {{ displayName }} Indigenous Territories
        </NuxtLink>
      </li> -->
    </ul>
  </div>
</template>
<script setup>
const props = defineProps({
  displayName: {
    type: String,
    required: true,
  },
  urlName: {
    type: String,
    required: true,
  },
  center: {
    type: Object,
    required: true,
  },
});

const encodedUrlName = computed(() => encodeURI(decodeUrlTitle(props.urlName)));
</script>
